import React from 'react';
import {
  Editor, convertFromRaw, EditorState,
  CompositeDecorator, Entity
} from 'draft-js';
import MUILink from '@material-ui/core/Link';

// Link shit
const Link = (props) => {
  const { url } = Entity.get(props.entityKey).getData();
  return (
    <MUILink href={url} target="_blank" rel="ugc">{props.children}</MUILink>
  )
}

function findLinkEntities(contentBlock, callback) {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      return (
        entityKey !== null &&
        Entity.get(entityKey).getType() === 'LINK'
      )
    },
    callback
  )
}

const decorators = [
  { strategy: findLinkEntities, component: Link }
]

export default function RTRenderer(props: { state: string; }) {
  let storedState;
  try {
    storedState = EditorState.createWithContent(convertFromRaw(JSON.parse(props.state)),new CompositeDecorator(decorators))
  }
  catch (e) {
    return null
  }
  return (
    <div className={"text-base whitespace-pre-line py-7 pb-10"}>
      <Editor editorState={storedState} readOnly={true} />
    </div>
  );
}